import { AiOutlineCloseCircle } from "react-icons/ai";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import imageNotFound from "../../Assets/images/ImageNotFound.jpg";

const cartItemTitle = (item) => {
    if (item.contentType == 1) return item.product?.title;
    return item.course?.title;
};

const cartItemImage = (item) => {
    let imagePath = "";
    if (item.contentType == 1) {
        imagePath =
            item.product?.productImages.length > 0
                ? item.product?.productImages[0].imagePath
                : null;
    } else {
        imagePath = item.course?.imagePath;
    }
    if (imagePath === null) return <img src={imageNotFound} alt="" />;
    return (
        <img
            alt={cartItemTitle(item)}
            src={
                axiosConfig.defaults.baseURL +
                `Images/${
                    item.contentType === 1 ? "ProductImage" : "CourseImage"
                }/` +
                item.contentId +
                "/" +
                imagePath
            }
        />
    );
};

export default function CartItem({
    item,
    itemDeleteHandler,
    quantityChangeHandler,
}) {

    return (
        <tr>
            <td>
                <AiOutlineCloseCircle
                    onClick={() => itemDeleteHandler(item.id)}
                />
            </td>
            <td className="product-td">
                {cartItemImage(item)}
                <h3>{cartItemTitle(item)}</h3>
            </td>
            <td className="price-td">{item.price.toLocaleString("fa-IR")}</td>
            <td>
                <div className="cart-count-btns">
                    {item.contentType == 1 ? (
                        <button
                            onClick={() => quantityChangeHandler(item.id, -1)}
                        >
                            -
                        </button>
                    ) : (
                        <></>
                    )}
                    <button>{item.quantity}</button>
                    {item.contentType == 1 ? (
                        <button
                            onClick={() => quantityChangeHandler(item.id, 1)}
                        >
                            +
                        </button>
                    ) : (
                        <></>
                    )}
                </div>
            </td>
            <td className="total-price">
                {(item.quantity * item.price).toLocaleString("fa-IR")}
            </td>
        </tr>
    );
}
